
export default function compleave( state = [], action = {} ){

	switch( action.type ){
		case 'COMP_GET_USERS':
			return action.compleave
		case 'COMP_SAVE_LEAVE':
			return action.compleave
		case 'COMP_GET_LEAVE':
			return action.compleave
		case 'COMP_DELETE_LEAVE':
			return action.compleave
		case 'COMP_UPDATE_LEAVE':
			return action.compleave
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/compassionate/compassionate.reducer.js